import { createInstance } from "i18next"
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import i18nConfig from "./config";

const initTranslations = async (locale: string, namespace: string[]) => {
  const i18nInstance = createInstance();

  await i18nInstance
    .use(initReactI18next)
    .use(
      resourcesToBackend(
        (language: string, namespace: string) =>
          import(`@/i18n/locales/${language}/${namespace}.json`),
      )
    )
    .init({
      lng: locale,
      fallbackLng: i18nConfig.defaultLocale,
      supportedLngs: i18nConfig.locales,
      defaultNS: namespace[0],
      fallbackNS: namespace[0],
      ns: namespace,
      preload: typeof window === "undefined" ? i18nConfig.locales : [],
    })

  return i18nInstance;
}

export default initTranslations;